import { STORAGE, API_ENDPOINT } from "../../constants";
import { HTTP } from "../http";
import { StorageService } from "../storage";

export const ExpensesService = {
  save: (data: {
    period: string,
    customer: string,
    field: string,
    date: string,
    type: string,
    concept: string,
    amount: number,
    comments: string,
  }) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.post<any, any>(`${API_ENDPOINT}operation/expenses`, {
      ...data,
      account,
    });
  },
  list: (period: string) => {
    const { account } = StorageService.get(STORAGE.USER);
    return HTTP.get<any, any>(`${API_ENDPOINT}operation/expenses/${account}/${period}`);
  },
};
